import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { View, Text, NativeSyntheticEvent, TextInputKeyPressEventData, StyleSheet } from "react-native";
import { ContentContainerProps } from "../../../interfaceTypes/ContentsProps";
import { FONT, SESSIONSTORAGE } from "../../../value/staticValues";
import { CustomCancelBtn } from "../../base/CustomCancelBtn";
import { CustomConfirmBtn } from "../../base/CustomConfirmBtn";
import { InputTextUnderLine } from "../../base/CustomInputText";
import AlertContent from "../../base/tamplate/AlartContent";
import ContentBox from "../../base/tamplate/ContentBox";

import { ReactComponent as BackImg } from '../../../img/ico-back-gray.svg';
import { base64Decoding } from "common/util";

interface AccountChangePwdProps extends ContentContainerProps {
    currentPwd: string;
    newPwd: string;
    newPwdCheck: string;
    setCurrentPwd: Function;
    setNewPwd: Function;
    setNewPwdCheck: Function;
    changePwdFn: Function;
    navigate: Function;
}

export default function AccountChangePwd(props:AccountChangePwdProps) {
    const {t} = useTranslation();
    const myPasswordYn = base64Decoding(sessionStorage.getItem(SESSIONSTORAGE.USER_ID)) === base64Decoding(sessionStorage.getItem(SESSIONSTORAGE.ACCOUNT_USER_ID));
    const newPwdInputRef = useRef<HTMLInputElement>(null);
    const newPwdCheckInputRef = useRef<HTMLInputElement>(null);

    return (
        <ContentBox title={""} subtitle={""} infoText={""} infoError={false}>
            <View style={{
                flexDirection:"row", alignItems: "center", justifyContent: "center",
                marginTop: 150,
            }}>
                <View style={{
                    width: 300, marginBottom: "auto"
                }}>
                    <View style={{flexDirection: "row", alignItems: "center", marginLeft: -40}}>
                        <BackImg
                            style={{cursor: "pointer"}}
                            onClick={() => { props.navigate(-1) }}
                        />
                        <Text style={{
                            fontFamily: FONT.MEDIUM,
                            fontSize: 24,
                            lineHeight: 36,
                            letterSpacing: -0.16,
                            color: "#333"
                        }}>
                            {t("CHANGE_PWD_TEXT")}
                        </Text>
                    </View>
                    <View style={{flexDirection: "row", marginTop: 27, width: 280}}>
                        <Text style={styles.Text}>
                            {t("CHANGE_PWD_START_INFO_TEXT")}&nbsp;
                            <Text style={{...styles.Text, color: "#db4d30"}}>
                                {t("CHANGE_PWD_RED_INFO_TEXT")}&nbsp;
                            </Text>
                            <Text style={styles.Text}>
                                {t("CHANGE_PWD_END_INFO_TEXT")}
                            </Text>
                        </Text>
                    </View>

                </View>

                <View style={{
                    width: 360,
                    marginLeft: 60
                }}>
                    {
                        myPasswordYn === true ?
                        <InputTextUnderLine
                            text={t("CURRENT_PWD_TEXT")}
                            inputprops={{
                                secureTextEntry: true,
                                placeholder: t("CURRENT_PWD_TEXT"),
                                onChangeText: (Text:string) => props.setCurrentPwd(Text.trim()),
                                onKeyPress: (event:NativeSyntheticEvent<TextInputKeyPressEventData>) => {
                                    if(event.nativeEvent.key === "Enter") {
                                        newPwdInputRef.current?.focus();
                                    }
                                }
                            }}
                        />
                        : null
                    }

                    <InputTextUnderLine
                        text={t("NEW_PWD_TEXT")}
                        inputref={newPwdInputRef}
                        inputprops={{
                            secureTextEntry: true,
                            placeholder: t("NEW_PWD_TEXT"),
                            onChangeText: (Text:string) => props.setNewPwd(Text.trim()),
                            onKeyPress: (event:NativeSyntheticEvent<TextInputKeyPressEventData>) => {
                                if(event.nativeEvent.key === "Enter") {
                                    newPwdCheckInputRef.current?.focus();
                                }
                            }
                        }}
                    />

                    <InputTextUnderLine
                        text={t("NEW_PWD_CHECK_TEXT")}
                        inputref={newPwdCheckInputRef}
                        inputprops={{
                            secureTextEntry: true,
                            placeholder: t("NEW_PWD_CHECK_TEXT"),
                            onChangeText: (Text:string) => props.setNewPwdCheck(Text.trim()),
                            onKeyPress: (event:NativeSyntheticEvent<TextInputKeyPressEventData>) => {
                                if(event.nativeEvent.key === "Enter") {
                                    props.changePwdFn()
                                }
                            }
                        }}
                    />

                    <View style={{
                        marginTop: 33
                    }}>
                        <AlertContent
                            size={33}
                            text={props.infoText}
                            error={props.infoError}
                        />
                    </View>


                    <View style={{flexDirection: "row", alignItems: "center", marginTop: 16}}>
                        <CustomCancelBtn
                            size={{width: 100, height: 52}}
                            fontsize={12}
                            text={t("CANCEL_TEXT")}
                            onPress={() => { props.navigate(-1) }}
                        />
                        <View style={{width: 10}}/>
                        <CustomConfirmBtn
                            size={{width: 250, height: 52}}
                            fontsize={12}
                            disabled={(props.newPwd === "") || (props.newPwdCheck === "") || (props.newPwd !== props.newPwdCheck)}
                            text={t("CHANGE_PWD_TEXT")}
                            onPress={() => {
                                props.changePwdFn()
                            }}
                        />
                    </View>
                </View>
            </View>
        </ContentBox>
    )
}

const styles = StyleSheet.create({
    Text: {
        fontFamily: FONT.REGULAR,
        fontSize: 14,
        lineHeight: 20,
        color: "#8c9299"
    }
})
